module.exports = __webpack_public_path__ + "static/media/astronaut.d31777b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/astronaut.png
// module id = 999
// module chunks = 0